import { ButtonsSettings } from '../../models/buttons-settings.model';

export class SetButtonsSettingsMessages {
  static readonly type = '[Message Buttons] Set buttons settings';

  constructor(public payload: ButtonsSettings) {
  }
}
